import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { ConciliacaoBancariaDinheiro } from '../domain/conciliacao-bancaria-dinheiro.model';

export class ConciliacaoBancariaDinheiroSerializer extends DomainSerializer<ConciliacaoBancariaDinheiro> {}
